import React from 'react';
import * as Icons from 'lucide-react';
import { Asterisk, ChevronsRight, ArrowUpRight, ShieldCheck } from 'lucide-react';
import { whyChoose } from '../data/mock';

const WhyChooseUs = () => {
  return (
    <section id="why-complise" className="relative py-16 lg:py-24 overflow-hidden bg-gradient-to-b from-white via-rose-50/35 to-white">
      <div className="absolute right-[-8rem] top-12 w-96 h-96 rounded-full border-[70px] border-rose-100/50 pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="relative grid lg:grid-cols-12 gap-8 mb-12 items-end">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 text-sm font-medium text-[#C41E3A] mb-4">
              <Asterisk className="w-4 h-4" /> Why Complise
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] font-extrabold text-neutral-900 leading-[1.05]">
              Reliable compliance support for <span className="text-[#C41E3A]">regulated brands</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-neutral-600 text-base md:text-lg leading-relaxed">
              A structured partner for advisory, documentation, testing coordination, authority follow-up, renewals and long-term compliance management.
            </p>
          </div>
        </div>

        <div className="relative grid lg:grid-cols-12 gap-5">
          <div className="lg:col-span-4 rounded-[2rem] border border-rose-200 bg-white p-7 md:p-8 overflow-hidden relative group shadow-[0_22px_70px_-45px_rgba(196,30,58,0.55)]">
            <div className="absolute -right-16 -top-16 w-48 h-48 rounded-full bg-rose-100 group-hover:scale-125 transition-transform duration-700" />
            <div className="relative flex flex-col h-full min-h-[410px]">
              <span className="w-14 h-14 rounded-2xl bg-[#C41E3A] text-white flex items-center justify-center mb-8 shadow-lg shadow-rose-200">
                <ShieldCheck className="w-6 h-6" />
              </span>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#C41E3A] font-bold mb-3">The Complise advantage</div>
              <h3 className="font-display text-3xl md:text-4xl font-extrabold text-neutral-900 leading-[1.04] mb-4">
                Fewer handoffs.<br />More control.<br /><span className="text-[#C41E3A]">Clear outcomes.</span>
              </h3>
              <p className="text-sm text-neutral-600 leading-relaxed max-w-sm mb-8">
                One operating partner connects brand teams, laboratories, factories and authorities across the complete compliance lifecycle.
              </p>
              <div className="mt-auto grid grid-cols-3 gap-3 pt-6 border-t border-neutral-200">
                {[
                  { v: '100+', l: 'Brands' },
                  { v: '14', l: 'Routes' },
                  { v: '30+', l: 'Industries' },
                ].map((s) => (
                  <div key={s.l}>
                    <div className="font-display text-2xl md:text-3xl font-extrabold text-neutral-900">{s.v}</div>
                    <div className="text-[9px] uppercase tracking-widest text-neutral-500">{s.l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {whyChoose.map((w) => {
              const Icon = Icons[w.icon] || Icons.Check;
              return (
                <div
                  key={w.id}
                  className="group relative bg-white border border-neutral-200 rounded-[1.5rem] p-5 md:p-6 hover:-translate-y-1.5 hover:border-[#C41E3A]/50 hover:shadow-[0_18px_45px_-25px_rgba(196,30,58,0.45)] transition-all duration-300 overflow-hidden"
                >
                  <span className="absolute right-4 top-2 font-display text-5xl font-extrabold text-neutral-100 group-hover:text-rose-100 transition-colors">{w.id}</span>
                  <div className="relative">
                    <span className="w-11 h-11 rounded-xl bg-rose-50 group-hover:bg-[#C41E3A] flex items-center justify-center mb-8 transition-colors">
                      <Icon className="w-5 h-5 text-[#C41E3A] group-hover:text-white transition-colors" />
                    </span>
                    <h3 className="font-display text-lg font-bold text-neutral-900 mb-2 leading-tight pr-5">{w.title}</h3>
                    <p className="text-xs text-neutral-600 leading-relaxed">{w.desc}</p>
                    <div className="mt-5 flex items-center gap-2 text-[10px] uppercase tracking-widest font-bold text-[#C41E3A] opacity-60 group-hover:opacity-100 transition-opacity">
                      Built into delivery <ArrowUpRight className="w-3.5 h-3.5" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-8 flex justify-center">
              <a
                href="#contact"
                className="pill-btn group inline-flex items-center gap-2 rounded-full bg-[#C41E3A] text-white pl-5 pr-1 h-11 text-sm font-semibold"
              >
                Build your compliance roadmap
                <span className="w-9 h-9 rounded-full bg-white flex items-center justify-center pill-arrow">
                  <ChevronsRight className="w-3.5 h-3.5 text-[#C41E3A]" />
                </span>
              </a>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
